import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Avatar, Button, List, Skeleton, Tooltip } from "antd";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";
import defaultImage from "../../assets/images/avatar-1.png";
import { Severty, ShowToast } from "../../helper/toast";
import noDataImage from "../../assets/images/new-notification-found.svg"
import { DeleteOutlined } from "@ant-design/icons";
import DeleteModal from "../../components/DeleteModal";

export const NotificationList = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { request } = useRequest();
  const [groupedList, setGroupedList] = useState({});
  const [showDelete, setShowDelete] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const dates = {
    today: moment().format("YYYY-MM-DD"),
    yesterday: moment().subtract(1, "days").format("YYYY-MM-DD"),
  };

  const fetchData = () => {
    setLoading(true);
    request({
      url: `${apiPath.notification}/from-users`,
      method: "GET",
      onSuccess: (data) => {
        const notifications = data.data || [];
        const grouped = {};

        notifications.forEach((item) => {
          const dateKey = moment(item.created_at).format("YYYY-MM-DD");
          if (!grouped[dateKey]) grouped[dateKey] = [];
          grouped[dateKey].push(item);
        });

        setGroupedList(grouped);
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
        console.error("Error fetching notifications");
      },
    });
  };

  const confirmDelete = (id = null) => {
    setDeleteTarget(id);
    setShowDelete(true);
  };

  const handleDelete = () => {
    const url = deleteTarget
      ? `${apiPath.deleteUserNotification}/${deleteTarget}`
      : `${apiPath.deleteUserNotification}/`;

    request({
      url,
      method: "DELETE",
      onSuccess: () => {
        ShowToast(
          deleteTarget ? "Notification deleted" : "All notifications deleted",
          Severty.SUCCESS
        );
        setShowDelete(false);
        setDeleteTarget(null);
        fetchData();
      },
      onError: () => {
        ShowToast("Unable to delete the notification", Severty.ERROR);
        setShowDelete(false);
        setDeleteTarget(null);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const isEmpty = Object.keys(groupedList).length === 0;

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }} className="main-new-notification-headekk">
        <h6>Notification List</h6>
        <Button danger icon={<DeleteOutlined />} onClick={() => confirmDelete(null)}>
          Delete All
        </Button>

      </div>

      {loading ? (
        <Skeleton active />
      ) : isEmpty ? (
        <div style={{ textAlign: "center", marginTop: 80 }}>
          <img
            src={noDataImage}
            alt="No Notifications"
            style={{ width: 180, opacity: 0.7 }}
          />
          <h3 style={{ marginTop: 20, color: "#888" }}>No notifications found</h3>
        </div>
      ) : (
        Object.keys(groupedList).map((groupedKey) => (
          <div className="notification-card" key={groupedKey} style={{ marginBottom: 20 }}>
            <h4 style={{ marginBottom: 16 }}>
              {groupedKey === dates.today
                ? "Today’s Notifications"
                : groupedKey === dates.yesterday
                  ? "Yesterday’s Notifications"
                  : groupedKey}
            </h4>
            <List
              itemLayout="horizontal"
              dataSource={groupedList[groupedKey]}
              renderItem={(item) => (
                <List.Item
                  onClick={() => {
                    const title = item.title?.toLowerCase();

                    if (title.includes("mp signup")) {
                      navigate("/mp"); // ✅ MP route
                    } else if (title.includes("constituent signup")) {
                      navigate("/constituent"); // ✅ Constituent route
                    }
                  }}

                  style={{ cursor: "pointer" }}
                  actions={[
                    <Tooltip title="Delete" color="purple" key="delete-tooltip">
                      <Button
                        className="btnStyle deleteDangerbtn new-notification-delete-iconn"
                        onClick={(e) => {
                          e.stopPropagation();
                          confirmDelete(item._id);
                        }}
                        icon={<DeleteOutlined />}
                      />
                    </Tooltip>,
                  ]}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        src={item?.from_id?.image || defaultImage}
                        style={{ backgroundColor: "#f56a00" }}
                      />
                    }
                    title={
                      <>
                        <strong>{item?.from_id?.name || "User"}</strong> – {item.title}
                      </>
                    }
                    description={item.description}
                  />
                </List.Item>

              )}
            />
          </div>
        ))
      )}

      <DeleteModal
        show={showDelete}
        hide={() => {
          setShowDelete(false);
          setDeleteTarget(null);
        }}
        onOk={handleDelete}
        title="Delete Notification"
        subtitle={
          deleteTarget
            ? "Are you sure you want to delete this notification?"
            : "Are you sure you want to delete all notifications?"
        }
      />
    </>
  );
};
